<div class="title" mat-dialog-title>Add API Credentials</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your account manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>ChatGPT Ads API Key</mat-label>
                <input matInput placeholder="Enter ChatGPT Ads API Key" formControlName="apiKey" data-cy="chatgpt-apikey-input">
                <mat-error
                    *ngIf="connectionForm.get('apiKey').errors && (connectionForm.get('apiKey').touched ||
                    connectionForm.get('apiKey').dirty)">
                    Invalid API Key</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="chatgpt-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>
